module.exports = __webpack_public_path__ + "static/media/ep1.8afc001e.png";